import React from "react";

import { useFireAnalyticsEvents } from "../../../../../analytics";
import {
    SourceKey,
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "../../../../../analytics/constants";
import { EmptySummary } from "../../../../common/empty-summary";
import { useFastshiftSelector } from "../../../../state";

export const EmptyAssessmentSummary: React.FC = () => {
    const selectedOrg = useFastshiftSelector((state) => state.selectedOrg);
    const orgs = useFastshiftSelector((state) => state.orgs);

    const { fireTrackEvent } = useFireAnalyticsEvents();

    // send track event once the empty migration summary section is loaded
    const loadStartRef = React.useRef<number>(Date.now());
    const hasSentTrackEvent = React.useRef<boolean>(false);

    React.useEffect(() => {
        const orgsLoaded =
            orgs && orgs.data && orgs.data.length > 0 && !orgs.pending;
        const selectedOrgLoaded = !!selectedOrg;

        if (orgsLoaded && selectedOrgLoaded && !hasSentTrackEvent.current) {
            const elapsed = Date.now() - loadStartRef.current;
            hasSentTrackEvent.current = true;
            const isOrgAdmin = orgs.data.length > 1;

            fireTrackEvent({
                action: ActionKey.DISPLAYED,
                actionSubject: ActionSubjectKey.SECTION,
                actionSubjectId: ActionSubjectIdKey.MIGRATION_SUMMARY_SECTION,
                source: SourceKey.FASTSHIFT_PORTAL_DASHBOARD_SCREEN,
                attributes: {
                    loadTime: elapsed,
                    isDisplayed: isOrgAdmin,
                    isEmptyBanner: true
                }
            });
        }
    }, [orgs, selectedOrg, fireTrackEvent]);

    return <EmptySummary orgId={selectedOrg?.id || ""} />;
};
